import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const ValueAdd = () => {
  const theme = useTheme();

  const items = [
    {
      title: 'Afinidad de nicho',
      text: 'La audiencia de Punto de Fe ya busca bienestar y guía espiritual; Nexus Cultural les ofrece el «siguiente paso» a través de sus actividades y «Sanando con los Ángeles».',
    },
    {
      title: 'Mística de producción',
      text: 'Margarita Toledo cuida cada detalle de sus aliados, asegurando que el mensaje llegue con la ética y el respeto que merece la propuesta de Nexus Cultural.',
    },
    {
      title: 'Autoridad digital',
      text: 'Con presencia en TNO Digest, quien busque sanación o cultura espiritual en Google puede encontrar esta alianza como referencia dentro del ecosistema TNO Network.',
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Diferencial
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          Por qué esta alianza es imbatible
        </Box>
      </Box>
      <Grid container spacing={3}>
        {items.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              sx={{
                p: 2,
                height: '100%',
                borderRadius: 2,
                border: `1px solid ${theme.palette.divider}`,
                bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
              }}
              data-aos="fade-up"
              data-aos-delay={i * 80}
            >
              <Typography variant="h6" gutterBottom fontWeight={700}>
                {item.title}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {item.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ValueAdd;
